var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"closable":_vm.closable,"scrollable":true,"adaptive":true,"height":"auto","width":"100%","classes":"v--modal my-6","max-width":600,"name":"login-modal"}},[_c('div',{staticClass:"px-4 lg:px-0 pt-8"},[_c('login-form-version-one')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }